// extracted by mini-css-extract-plugin
export default {"root":"rJEfrLC_ReYy4A9jBfgB","th":"Vb9asRpGkCF4_K08gtRg","thContent":"SyqW3pW2XqcaG4NsH3p2","placeHolderShimmer":"v8TVkSyFKxdhjGd_XwGd"};